<template>
  <div :class="['full-width col', { 'bg-grey-1': !isMobile }]">
    <!-- Content shown if the page is in a loading state -->
    <SAIPageSpinner v-if="loading" />

    <!-- Content shown above the double / single column layout -->
    <slot v-if="!loading" name="header" />

    <div
      v-if="!loading"
      :class="[
        'relative-position',
        { 'row desktop-single-column q-px-md': !isMobile }
      ]"
    >
      <!-- Card will be shown in a left column for desktop -->
      <div v-if="!isMobile" class="q-mr-md q-pr-sm">
        <slot name="card" />
      </div>

      <!-- Content shown in a single column for mobile -->
      <div
        :class="[
          'q-px-md q-pb-lg',
          { 'q-mb-lg bg-white rounded-borders-lg col': !isMobile }
        ]"
      >
        <!-- Card will be shown at the top of the single column for mobile -->
        <slot name="card" v-if="isMobile" />

        <slot name="details" />
      </div>
    </div>
  </div>
</template>

<script>
import { SAIPageSpinner } from 'ecx.saigon.ui.common';

export default {
  name: 'DetailContentsLayout',
  props: {
    isMobile: Boolean,
    loading: Boolean
  },
  components: {
    SAIPageSpinner
  }
};
</script>
